import React from 'react';

const ContributorResultsContext = React.createContext();

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setLoadingAllWires':
      return { ...state, loadingAllWires: payload };
    case 'setAllWires':
      return { ...state, allWires: payload };
    case 'setLoadingLatestWires':
      return { ...state, loadingLatestWires: payload };
    case 'setLatestWires':
      return { ...state, latestWires: payload };
    case 'setLoadingMentionedWires':
      return { ...state, loadingMentionedWires: payload };
    case 'setMentionedWires':
      return { ...state, mentionedWires: payload };
    case 'setKeywords':
      return { ...state, keywords: payload };
    case 'setStockCodes':
      return { ...state, stockCodes: payload };
    case 'setColleagues':
      return { ...state, colleagues: payload };
    case 'setSimilarContributors':
      return { ...state, setSimilarContributors: payload };
    default:
      throw new Error();
  }
};

const defaultState = {
  loadingAllWires: null,
  allWires: [],
  loadingLatestWires: null,
  latestWires: [],
  loadingMentionedWires: null,
  mentionedWires: [],
  keywords: [],
  stockCodes: [],
  colleagues: [],
  setSimilarContributors: [],
};

export default ContributorResultsContext;
export {
  reducer,
  defaultState,
};
